import ol_source_Vector from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import ol_Collection from 'ol/Collection';
import Feature from 'ol/Feature';

/**
 * A layer with draw features. It can draw many features at a time.
 * @constructor
 * @extends {VectorLayer}
 * @param {Object} options Control options, extends olx.layer.VectorOptions.
 */
export default class MultiFeature extends VectorLayer {
  constructor(options = {}) {
    options.source = new ol_source_Vector({
      features: new ol_Collection(),
    });

    super(options);
  }

  /**
     * Get all features in the layer.
     * @return {Array<Feature>}
     */
  getFeatures() {
    return this.getSource().getFeatures();
  }

  /**
     * Sugar to draw a geometry.
     * @param {ol.geom.Geometry} geometry A geometry.
     * @param {string} id The id of the geometry when its added as feature in layer.
     */
  drawPolygon(geometry, id) {
    const feature = new Feature(geometry);
    if (id) {
      feature.setId(id);
    }
    this.drawFeature(feature);
  }

  /**
     * Sugar to draw many geometries.
     * @param {Array<ol.geom.Geometry>} geometry A geometry array.
     */
  drawPolygons(geometries) {
    const features = [];
    for (const geom of geometries) {
      features.push(new Feature(geom));
    }
    this.drawFeatures(features);
  }

  /**
     * Draw a feature in the layer.
     * @param {Feature} feature The feature to draw.
     * @param {string} [idInLayer] The feature id in the layer.
     */
  drawFeature(feature, idInLayer) {
    const id = idInLayer || feature.getId() || feature.ol_uid;
    if (!this.getSource().getFeatureById(id)) {
      this.getSource().addFeature(feature);
    }
  }

  /**
     * Remove a feature in the layer.
     * @param {ol.Feature} feature The feature to draw.
     */
  removeFeature(feature) {
    if (this.getSource().hasFeature(feature)) {
      this.getSource().removeFeature(feature);
    }
  }

  /**
     * Draw a feature in the layer.
     * @param {Array<ol.Feature>} features An array of features to draw.
     */
  drawFeatures(features) {
    for (const feat of features) {
      this.drawFeature(feat);
    }
  }

  /**
     * Clear the features.
     */
  clear() {
    this.getSource().clear();
    this.features_ = {};
  }
}
